import ThemeResource from "../../../../../OBJRep/ThemeResource";
import Resource from "../../../../../OBJRep/Resource";
import {
  themeHasDefaultStyles,
  toDataURL,
} from "../../../../../services/Utils";

/**
 * Creates a ThemeResource object from a theme API response object.
 * @param {object} theme - The theme object from API (with styles property)
 * @returns {object} ThemeResource
 */
export async function createThemeResource(theme, token) {
  if (!theme || !theme.styles) return null;
  const displayUrl = await toDataURL(theme.location + "/", token);
  const hasDefaultStyles = themeHasDefaultStyles(theme);
  const resource = Resource(
    theme.urlTmp || displayUrl,
    theme.location || "",
    theme.name || "",
    theme.premium || false,
  );
  return ThemeResource(
    resource,
    theme.styles.mainTextColor,
    theme.styles.secondaryTextColor,
    theme.styles.bgMainColor,
    theme.styles.bgSecondaryColor,
    theme.styles.mainPriceTheme,
    theme.styles.secondaryPriceTheme,
    theme.styles.mainPriceTextColor,
    theme.styles.secondaryPriceTextColor,
    hasDefaultStyles,
  );
}
